import React from 'react';
import classes from './ToggleButton.module.scss';
import clsx from 'clsx';

import Txt from '../Txt/Txt';

export interface ToggleButtonProps {
  onClick: (value: boolean) => void;
  falseText?: string;
  trueText?: string;
  disabled?: boolean;
  checked?: boolean;
  id: string;
  children?: React.ReactNode;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  falseText,
  trueText,
  checked,
  disabled,
  id,
  onClick,
  children,
  ...rest
}) => {
  return (
    <div className={clsx(classes.root, disabled && classes.disabled)}>
      <button
        type="button"
        onClick={() => onClick(false)}
        disabled={disabled}
        className={clsx(disabled && classes.disabled)}
      >
        <Txt
          component="p"
          className={clsx(
            classes.text,
            `${checked || checked === undefined ? classes.inactiveText : classes.activeText}`,
          )}
        >
          {falseText || 'Off'}
        </Txt>
      </button>

      <label htmlFor={`toggleButton-${id}`} className={classes.label}>
        <div className={clsx(classes.switch)}>
          <span
            className={clsx(
              classes.slider,
              checked && classes.sliderChecked,
              disabled && classes.disabled,
            )}
          >
            <span
              className={clsx(
                classes.circle,
                checked === undefined && classes.unanswered,
                checked && classes.circleChecked,
                disabled && classes.sliderDisabled,
              )}
            />
          </span>
        </div>
        <input
          id={`toggleButton-${id}`}
          type="checkbox"
          className={classes.input}
          checked={checked}
          disabled={disabled}
          onChange={() => onClick(!checked)}
          aria-label={`toggleButton-${id}`}
        />
      </label>
      <button
        type="button"
        onClick={() => onClick(true)}
        disabled={disabled}
        className={clsx(disabled && classes.disabled)}
      >
        <Txt
          component="p"
          className={clsx(classes.text, `${checked ? classes.activeText : classes.inactiveText}`)}
        >
          {trueText || 'On'}
        </Txt>
      </button>
    </div>
  );
};
